// React Dependencies
import React, { useState, useRef } from 'react';

// External Dependencies
import { Icon, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

// Internal Dependencies
import TagGroupTable from './table';
import MText from '../../common/MText';
import Colours from '../../../styles/colours';
import GroupModal from './groupModal';

const TagsPopularTagGroupList = () => {
  const [openModal, setOpenModal] = useState(false);
  const tableRef = useRef(null);

  const handleCloseModal = () => {
    setOpenModal(false);
    if (tableRef.current) {
      tableRef.current.refreshTable();
    }
  };

  return (
    <div>
      <div className="content-header mb-3">
        <div className="d-flex align-items-center">
          <Link to="/admin/tags/popular" className="d-flex align-items-center mr-2">
            <Icon className="back">arrow_back</Icon>
          </Link>
          <MText variant="h1" text="Manage Tag Group" bold colour={Colours.Gray6} />
        </div>
        <Button
          variant="contained"
          onClick={() => setOpenModal(true)}
        >
          Add New Group
        </Button>
      </div>

      <TagGroupTable ref={tableRef} />

      {openModal && (
        <GroupModal onClose={handleCloseModal} group={null} />
      )}
    </div>
  );
};

export default TagsPopularTagGroupList;
